import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full p-6" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex justify-between items-center mb-2" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_6 = { class: "text-xl font-bold" }
const _hoisted_7 = { class: "text-gray-600 mb-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_10 = { class: "w-full bg-gray-200 rounded-full h-2.5" }
const _hoisted_11 = {
  key: 1,
  class: "bg-gray-50 rounded-lg p-6 text-center border border-gray-200"
}
const _hoisted_12 = { class: "flex flex-col items-center" }
const _hoisted_13 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6" }
const _hoisted_14 = { class: "lg:col-span-2" }
const _hoisted_15 = { class: "bg-white rounded-lg shadow-md overflow-hidden" }
const _hoisted_16 = { class: "lg:col-span-1" }
const _hoisted_17 = {
  key: 0,
  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50"
}
const _hoisted_18 = { class: "bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative" }
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "mb-6" }
const _hoisted_21 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_22 = { class: "flex justify-end space-x-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 1,
  class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50"
}
const _hoisted_27 = { class: "bg-white rounded-lg shadow-lg w-full max-w-md p-6" }
const _hoisted_28 = { class: "flex justify-end space-x-3" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_31 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskView = _resolveComponent("TaskView")!
  const _component_ActivityFeed = _resolveComponent("ActivityFeed")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "text-2xl font-bold text-primary" }, "Dashboard", -1)),
          _createElementVNode("div", null, [
            (_ctx.canTriggerForecast)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openNewForecastModal && _ctx.openNewForecastModal(...args))),
                  class: "bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 transition-colors"
                }, _cache[10] || (_cache[10] = [
                  _createElementVNode("svg", {
                    class: "h-5 w-5 mr-2 inline",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                    })
                  ], -1),
                  _createTextVNode(" New Forecast ")
                ])))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-muted-foreground" }, "Overview of tasks, activities, and recent updates", -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.forecastingProcesses.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forecastingProcesses, (process) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: process.id,
                  class: "bg-white rounded-lg shadow-md p-6"
                }, [
                  _createElementVNode("h2", _hoisted_6, _toDisplayString(process.name) + " Reporting Period", 1),
                  _createElementVNode("p", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(process.start_date)) + " - " + _toDisplayString(_ctx.formatDate(process.end_date)) + " ", 1),
                    (_ctx.getDaysRemaining(process.end_date) > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(_ctx.getDaysRemaining(process.end_date)) + " days remaining) ", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, " (Overdue) "))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "bg-blue-600 h-2.5 rounded-full",
                      style: _normalizeStyle({ width: _ctx.getProgressPercentage(process.start_date, process.end_date) + '%' })
                    }, null, 4)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"mb-4 p-3 bg-gray-100 rounded-full\"><svg class=\"h-8 w-8 text-gray-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z\"></path></svg></div><h3 class=\"text-lg font-medium text-gray-900 mb-2\">No Active Reporting Periods</h3><p class=\"text-gray-500 mb-6\">Start a new forecast process to begin tracking reporting periods</p>", 3)),
                (_ctx.canTriggerForecast)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNewForecastModal && _ctx.openNewForecastModal(...args))),
                      class: "inline-flex items-center px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
                    }, _cache[13] || (_cache[13] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5 mr-2",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                        })
                      ], -1),
                      _createTextVNode(" Start New Forecast ")
                    ])))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"p-4 border-b border-gray-200 flex justify-between items-center\"><div><h2 class=\"text-xl font-semibold\">Tasks</h2><p class=\"text-sm text-gray-500\">Manage and track reporting tasks</p></div><button class=\"p-2 rounded-md hover:bg-gray-100\"><svg class=\"h-5 w-5 text-gray-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M19 9l-7 7-7-7\"></path></svg></button></div>", 1)),
            _createVNode(_component_TaskView, {
              myTasks: _ctx.myTasks,
              allTasks: _ctx.openTasks,
              reminders: _ctx.reminders,
              overdueRemindersCount: _ctx.overdueRemindersCount,
              canViewReminders: _ctx.canViewReminders
            }, null, 8, ["myTasks", "allTasks", "reminders", "overdueRemindersCount", "canViewReminders"])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_ActivityFeed, { activities: _ctx.activities }, null, 8, ["activities"])
        ])
      ])
    ]),
    (_ctx.showForecastModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showForecastModal = false)),
              class: "absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            }, _cache[16] || (_cache[16] = [
              _createElementVNode("span", { class: "text-xl" }, "×", -1)
            ])),
            _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "text-xl font-bold mb-2" }, "Create New Reporting Period", -1)),
            _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-gray-600 mb-6" }, "Set up a new reporting period by providing a name and date range.", -1)),
            _createElementVNode("div", _hoisted_19, [
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                for: "periodName",
                class: "block text-sm font-medium text-gray-700 mb-1"
              }, "Period Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "periodName",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.periodName) = $event)),
                placeholder: "e.g. Q3 2025",
                class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              }, null, 512), [
                [_vModelText, _ctx.periodName]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Date Range", -1)),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", {
                    for: "startDate",
                    class: "block text-sm text-gray-700 mb-1"
                  }, "Start Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "startDate",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.startDate) = $event)),
                    class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  }, null, 512), [
                    [_vModelText, _ctx.startDate]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", {
                    for: "endDate",
                    class: "block text-sm text-gray-700 mb-1"
                  }, "End Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    id: "endDate",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endDate) = $event)),
                    class: "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  }, null, 512), [
                    [_vModelText, _ctx.endDate]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showForecastModal = false)),
                class: "px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.confirmCreateForecast && _ctx.confirmCreateForecast(...args))),
                class: "px-4 py-2 bg-blue-700 text-white rounded-md hover:bg-blue-800 transition-colors",
                disabled: _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _cache[21] || (_cache[21] = [
                      _createElementVNode("svg", {
                        class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ], -1),
                      _createTextVNode(" Processing... ")
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_25, "Create Period"))
              ], 8, _hoisted_23)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "text-lg font-medium mb-3" }, "Confirm Forecast Creation", -1)),
            _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-gray-600 mb-6" }, "Are you sure you want to create a new forecasting process? This action cannot be undone.", -1)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showConfirmDialog = false)),
                class: "px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.startForecastProcess && _ctx.startForecastProcess(...args))),
                class: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors",
                disabled: _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _cache[24] || (_cache[24] = [
                      _createElementVNode("svg", {
                        class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        })
                      ], -1),
                      _createTextVNode(" Processing... ")
                    ])))
                  : (_openBlock(), _createElementBlock("span", _hoisted_31, "Yes, Create"))
              ], 8, _hoisted_29)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}